import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export enum ESSENTIALS_ACCESS {
  ALLOWED = 'allowed',
  DISABLED = 'disabled',
  /** The client's details or customer list are still loading. */
  LOADING = 'loading',
  /**
   * Loaded, but the client's customer config can't be found (no employer, no matching customer —
   * internal customers are filtered out of the list — or the list failed to load). Defer to the backend.
   */
  UNRESOLVED = 'unresolved',
}

const matchesEmployer = (customer: CustomerInfo, employer: string) =>
  customer.value?.toLowerCase() === employer ||
  customer.customer_aliases?.some((alias) => alias?.toLowerCase() === employer)

/**
 * Resolves whether a client's customer has Essentials turned off.
 *
 * `library_disabled` arrives from the customers API as the string 'true'/'false', so it must be
 * compared loosely; a strict `=== true` never matches and silently grants access (LCDELIVERY-7927).
 */
export const getEssentialsAccess = (customers: CustomerInfo[], employer?: string): ESSENTIALS_ACCESS => {
  if (!employer) {
    return ESSENTIALS_ACCESS.UNRESOLVED
  }
  const customer = customers.find((c) => matchesEmployer(c, employer.toLowerCase()))
  if (!customer) {
    return ESSENTIALS_ACCESS.UNRESOLVED
  }
  return `${customer.library_disabled}` === 'true' ? ESSENTIALS_ACCESS.DISABLED : ESSENTIALS_ACCESS.ALLOWED
}
